<section class="priority-table-wrapper" *ngIf="init">
  <gen-dynamic-form-table
    class="priority-table priority-tables-selector"
    *ngFor="let item of group.tablesConfig; index as i"
    [tableTitle]="item.tableTitle"
    [formItems]="formItems[i].widgetPayload.formConfig"
    [data]="configData[i]"
    [formVertical]="item.formVertical"
    [itemRequiredMessage]="'Click here to edit'"
    [popupMode]="popupMode"
    [editMode]="editMode"
    [showDeleteButton]="false"
    [prioritizeAvailable]="prioritizeAvailable"
    [prioritizeTrackByField]="item.prioritizeTrackByField"
    [listenToDataChange]="listenToDataChange"
    [itemTitle]="item.listName"
    [titleClass]="group?.tableTitleCssClass"
    (itemUpdateEmitter)="updateContainedData($event, i)"
    [itemOverridesRef]="itemOverrides"
    [itemNgClassRef]="getPriorityTableItemNgClass.bind(this)"
    [defaultTabletitle]="formTitlesTable[i]"
    [emptyMessageDisplay]="item.emptyMessageDisplay"
    [submitted]="widgetFormInstanceSubmitted"
    [skipWidgetUpdateValueCallback]="true"
    [disabled]="isExternal"
    [deleteFieldModelName]="item.deleteFieldModelName"
  >
  </gen-dynamic-form-table>
</section>

<section class="priority-table-add-item">
  <gen-dynamic-form class="add-form"
                    [formName]="appendFormId"
                    [resetForm]="reset"
                    (formChange)="updateLastItems($event)"
                    [popupMode]="true"
                    [listenToDataChange]="true"
                    [submitted]="submitted"
                    (validateChange)="updateValidate($event)"
                    [disabledForced]="isExternal"
                    [formVertical]="false"
                    [editMode]="addFormEditMode"
                    (resetStatusEmitter)="reset = $event"
  ></gen-dynamic-form>
</section>
<section class="priority-table-add-item">
  <gen-button class="add-form-button" [iconClass]="'icon__plus'" (click)="addItem()" [type]="'quite'"></gen-button>
</section>
